import React from 'react';
import randomstring from 'uuid/v4';

import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';

import Send from '@material-ui/icons/Send';
import Timer from '@material-ui/icons/Timer';
import CalendarToday from '@material-ui/icons/CalendarToday';
import Close from '@material-ui/icons/Close';
import Beenhere from '@material-ui/icons/Beenhere';

import Delete from '@material-ui/icons/Delete';
import Save from '@material-ui/icons/Save';
import PermIdentity from '@material-ui/icons/PermIdentity';

import AttachFile from '@material-ui/icons/AttachFile';

import DownshiftMultiple from '../../inputs/MultipleInput';

import ProtectedImg from './ProtectedImg';
import Editor from './Editor';
import FileUpload from './FileUpload';
import RoleTree from './RoleTree';

class NewCommunications extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            id: undefined,
            requiereRespuesta: 0,
            prioridad: false,
            asunto: '',
            cuerpo: '',
            programada: '',
            limite: '',
            adjuntos: [],
            selectedusers: [],
            roles: [],
            selectedroleslocals: [],
            suggestions: []
        };

        if (props.isNew && !this.state.created) {
            props.addCommunication({})
                 .catch((error) => { this.props.showError(error.message, error.type) })
        }

        this.interval = setInterval(() => {
            this.updateAndSave();
        }, 15000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }


    static getDerivedStateFromProps(props, state) {
        const { info, communication } = props;

        if (info !== state.info || (communication !== state.communication && (props.isNew || props.id.toString() === communication.id.toString()))) {
            state.suggestions =
                info !== undefined && info.security !== undefined
                    ? info.security.destinatarios.filter((f) => f.type === 'user')
                    : undefined;

            state.roles = info !== undefined && info.security !== undefined
                ? info.security.destinatarios.filter((f) => f.type === 'rol')
                : undefined;

            state.info = info;

            if (props.isNew) {
                state.id = communication.id;
                state.communication = communication;
            } else if (props.id.toString() === communication.id.toString()) {
                state.communication = communication;
                state.requiereRespuesta = communication.requiereRespuesta ? communication.requiereRespuesta : 0;
                state.prioridad = communication.prioridad === 1;
                state.asunto = communication.asunto ? communication.asunto : '';
                state.cuerpo = communication.cuerpo ? communication.cuerpo : '';
                state.programada = communication.programada ? communication.programada.replace(' ', 'T') : '';
                state.limite = communication.limite ? communication.limite.replace(' ', 'T') : '';
                state.adjuntos = communication.adjuntos && communication.adjuntos.length > 0 ? communication.adjuntos : [];

                state.selectedusers = communication.destino
                    ? communication.destino.reduce((arr, item) => {
                        if (item.idUsuario && !arr.some((l) => l.type === 'user' && l.id === item.idUsuario)) {
                            const user = state.suggestions.find(f => f.type === 'user' && f.id === item.idUsuario);
                            arr.push(user);
                        }
                        return arr;
                    }, [])
                    : [];
                state.selectedroleslocals = communication.destino
                    ? communication.destino.filter((f) => !f.idUsuario)
                    : [];
                state.id = communication.id;
            }

            return state;
        }
        return null;
    }

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value, edit: true });
    };

    handleChecked = (event) => {
        this.setState({ [event.target.name]: event.target.checked, edit: true });
    };

    handleRemoveDate = (nombre) => (event) => {
        this.setState({ [nombre]: '', edit: true });
    };

    handleUpdate = (name, values) => {
        this.setState({ [name]: values, edit: true });
    };

    updateAndSave = (send, destination) => {

        const {
            id,
            asunto,
            cuerpo,
            adjuntos,
            requiereRespuesta,
            programada,
            limite,
            prioridad,
            selectedusers,
            selectedroleslocals,
            edit
        } = this.state;
        const direct = requiereRespuesta !== "2" ? selectedusers.map((item) => { return { idUsuario: item.id } }) : [];

        const comm = {
            id: id,
            asunto: asunto,
            cuerpo: cuerpo,
            requiereRespuesta: requiereRespuesta,
            destino: direct.concat(selectedroleslocals),
            programada: programada ? programada.replace('T', ' ') : undefined,
            limite: limite ? limite.replace('T', ' ') : undefined,
            prioridad: prioridad,
            adjuntos: adjuntos

        };

        if (edit) {

            this.props.editCommunication(comm, true)
                .then(() => {
                    if (send) {
                        this.props.sendCommunication(comm)
                            .then(() => {
                                this.props.history.push(destination);
                            })
                            .catch((error) => { this.props.showError(error.message, error.type) })
                    }
                    else {
                        this.setState({ edit: false });
                    }
                })
                .catch((error) => { this.props.showError(error.message, error.type) });

        } else if (send) {

            this.props.sendCommunication(comm)
                .then(() => {
                    this.props.history.push(destination);
                })
                .catch((error) => { this.props.showError(error.message, error.type) });

        }

    };

    isOk = () => {
        const {
            asunto,
            cuerpo,
            selectedusers,
            selectedroleslocals,
            requiereRespuesta
        } = this.state;
        return !!asunto
            && !!cuerpo
            && (
                (selectedusers.length > 0 && requiereRespuesta !== "2")
                || selectedroleslocals.length > 0
            );
    }

    submit = () => {
        this.updateAndSave(true, '/communications/sent');
    }

    exit = () => {
        this.props.history.push('/communications/sent');
    }

    save = () => {
        this.updateAndSave(false, '/communications/sent');
    }

    handleDelete = (event) => {
        this.props.deleteCommunication(this.state.id)
            .then(() => {
                this.props.history.push('/communications/sent');
            })
            .catch((error) => {
                this.props.showError(error.message, error.type);
            })
    }

    getFiles = (arr) => {
        const { adjuntos } = this.state;
        this.setState({ adjuntos: adjuntos.concat(arr) });
    }

    render() {
        const {
            asunto,
            cuerpo,
            requiereRespuesta,
            programada,
            limite,
            prioridad,
            selectedusers,
            selectedroleslocals,
            suggestions,
            roles,
            edit,
            adjuntos,
            id
        } = this.state;
        const { intl } = this.props;

        //console.log('render new communications');

        return (
            <div
                className={
                    'flex_50 padding_top_12 bg_white newcommunication overflow_y_scroll showbar'
                }
            >
                <div className={'flex_full_column padding_borders_flat '}>
                    <div className="flex_auto_row align_center margin_top_24 elements_from_right">
                        <div className="flex_auto_row">
                            <div
                                className={" align_center flex_auto_row " + (edit ? 'button-keep' : 'button-save')}
                                onClick={this.save}
                            >
                                <Save className={" margin_right_6 " + (edit ? 'c_pea' : 'c_disabled')} />
                                {intl.formatMessage({ id: 'communication_keep' })}
                            </div>
                        </div>
                        <div className="flex_full_row" />
                        {this.isOk() &&
                            <div
                                className={"button-send align_center flex_auto_row "}
                                onClick={this.submit}
                            >
                                <Send className="c_bluish margin_right_6" />
                                {intl.formatMessage({ id: 'communication_send' })}
                            </div>
                        }
                        <div className="margin_left_6 flex_auto_row">
                            <div
                                className="button-remove align_center flex_auto_row margin_right_6"
                                onClick={this.handleDelete}
                            >
                                <Delete className="c_lipstick hand" />
                                {intl.formatMessage({ id: 'communication_remove' })}
                            </div>
                        </div>
                        <Close className="c_disabled margin_left_2 hand" onClick={this.exit} />
                    </div>
                    <div className="flex_auto_row align_center margin_top_24">
                        <TextField
                            id="asunto"
                            name="asunto"
                            label={intl.formatMessage({ id: 'communication_title' })}
                            fullWidth
                            className="margin_bottom_12 padding_top_24"
                            value={asunto}
                            onChange={this.handleChange}
                            InputLabelProps={{ shrink: true }}
                        />
                    </div>
                    <div className="flex_auto_column align_center margin_top_24">
                        <Editor
                            {...this.props}
                            id={randomstring()}
                            name="cuerpo"
                            value={cuerpo}
                            onChange={this.handleChange}
                        />
                    </div>
                    <div className="flex_auto_column margin_top_24">
                        <div className="flex_auto_row align_center">
                            <AttachFile className="c_disabled margin_right_2 communications_icon" />
                            <p className="flex_full_row barlow_regular_small c_slate">
                                {intl.formatMessage({ id: 'attach' })}
                            </p>
                        </div>
                    </div>
                    <div className="flex_auto_row align_center">
                        <FileUpload
                            {...this.props}
                            multiple
                            communication
                            onDone={this.getFiles.bind(this)}
                            instance={this.props.instance}
                            id={id}
                        />
                        {adjuntos.length > 0 &&
                            adjuntos.map((a, index) => {
                                return (
                                    <ProtectedImg
                                        {...this.props}
                                        key={`thumbnail-${id}-${a.id}`}
                                        communication
                                        edit
                                        id={a.id}
                                        parent={id}
                                        name={a.nombre}
                                        src={`${process.env.REACT_APP_API_COMMUNICATIONS}/${id}/adjunto/${a.id}/miniatura?token=${sessionStorage.token.replace('Bearer ', '')}`}
                                        download={`${process.env.REACT_APP_API_COMMUNICATIONS}/${id}/adjunto/${a.id}/datos/${a.nombre}?token=${sessionStorage.token.replace('Bearer ', '')}`}
                                    />)
                            })
                        }
                    </div>
                    <div className="flex_auto_row margin_top_24 align_center">
                        <div className="flex_full_row">
                            <div className="flex_auto_row button-message barlow_regular_small c_lipstick border_lipstick">
                                {intl.formatMessage({ id: 'communication_text_urgent' })}
                            </div>
                        </div>
                        <div className="flex_auto_column">
                            <Switch
                                name={'prioridad'}
                                checked={prioridad}
                                onChange={this.handleChecked}
                                value="prioridad"
                                color="secondary"
                            />
                        </div>
                    </div>
                    <div className="flex_auto_row margin_top_24 align_center">
                        <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                            <InputLabel htmlFor="age-native-simple">
                                {intl.formatMessage({ id: 'communication_text_answer_require' })}
                            </InputLabel>
                            <Select
                                native
                                value={requiereRespuesta}
                                fullWidth
                                onChange={this.handleChange}
                                inputProps={{ name: 'requiereRespuesta', id: 'requiereRespuesta' }}
                            >
                                <option key={randomstring()} value={0}>{intl.formatMessage({ id: 'communication_no_answer_requested' })}</option>
                                <option key={randomstring()} value={1}>{intl.formatMessage({ id: 'communication_allow_answer' })}</option>
                                <option key={randomstring()} value={2}>{intl.formatMessage({ id: 'communication_request_answer' })}</option>
                                <option key={randomstring()} value={3}>{intl.formatMessage({ id: 'communication_request_answer_all' })}</option>
                            </Select>
                        </FormControl>
                    </div>

                    <div className="flex_auto_row margin_top_24  align_center barlowcondensed_medium c_state">
                        <Timer className="c_disabled margin_right_6" />
                        {intl.formatMessage({ id: 'communication_sent_date' })}
                    </div>
                    <div className="flex_auto_row align_center margin_top_8">
                        <TextField
                            fullWidth
                            name={'programada'}
                            id={'programada-date'}
                            //label={intl.formatMessage({ id: 'date' })}
                            type="datetime-local"
                            value={programada ? programada : ''}
                            onChange={this.handleChange}
                            className="barlow_regular_small"
                            InputLabelProps={{ shrink: true }}
                            InputProps={{ inputProps: { min: new Date().toISOString().slice(0, 16) } }}
                        />
                        <Close
                            className="c_lipstick hand"
                            onClick={this.handleRemoveDate('programada')}
                        />
                    </div>
                    <div className="flex_auto_row margin_top_24 align_center barlowcondensed_medium c_state">
                        <CalendarToday className="c_disabled margin_right_6" />
                        {intl.formatMessage({ id: 'communication_limit_date' })}
                    </div>
                    <div className="flex_auto_row align_center margin_top_8">
                        <TextField
                            fullWidth
                            name={'limite'}
                            id={'limite'}
                            type="datetime-local"
                            value={limite ? limite : ''}
                            onChange={this.handleChange}
                            InputLabelProps={{ shrink: true }}
                            InputProps={{ inputProps: { min: new Date().toISOString().slice(0, 16) } }}
                        />
                        <Close
                            className="c_lipstick hand"
                            onClick={this.handleRemoveDate('limite')}
                        />
                    </div>
                    {requiereRespuesta !== "2" &&
                        <div className="flex_auto_column align_center margin_top_24 width100">
                            <div className="flex_auto_row width100">
                                <PermIdentity className="c_disabled margin_right_6" />
                                <div className="flex_auto_row button-message barlowcondensed_medium c_state">
                                    {intl.formatMessage({ id: 'communication_send_to' })}
                                </div>
                            </div>
                            <DownshiftMultiple
                                id="execute_permits"
                                label={intl.formatMessage({ id: 'communication_send_direct_label' })}
                                suggestions={suggestions}
                                value={selectedusers}
                                name="selectedusers"
                                onChange={this.handleUpdate}
                            />
                        </div>
                    }
                    <div className="flex_auto_column margin_top_24">
                        <div className="flex_auto_row align_center">
                            <Beenhere className="c_disabled margin_right_2 communications_icon" />
                            <p className="flex_full_row barlow_regular_small c_slate">
                                {intl.formatMessage({ id: 'communication_locals_roles' })}
                            </p>
                        </div>
                    </div>
                    <RoleTree
                        {...this.props}
                        tree={this.props.info.security.hierarchies}
                        value={selectedroleslocals}
                        suggestions={roles}
                        onChange={this.handleUpdate}
                        handleUpdate={this.handleUpdate}
                    />
                    <div className="flex_auto_row  align_center margin_top_8 margin_bottom_48"></div>
                </div>
            </div >
        );
    }
}

export default NewCommunications;



// WEBPACK FOOTER //
// ./src/components/complex/communications/NewCommunications.js